export default __webpack_public_path__ + "static/ebot-c4e3a4433ed2c91f586865df90132c8e.png";